import { render, staticRenderFns } from "./PainelComiteLogisticaSustentavel.vue?vue&type=template&id=aa217324"
import script from "./PainelComiteLogisticaSustentavel.vue?vue&type=script&lang=js"
export * from "./PainelComiteLogisticaSustentavel.vue?vue&type=script&lang=js"
import style0 from "./PainelComiteLogisticaSustentavel.vue?vue&type=style&index=0&id=aa217324&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports